import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { RecordList } from '@app/models/record.model';
import { ApiService } from '@app/services/api.service';
import { ClearRecordList, RemoveInitFacesheetList } from '@app/store/record/record.classes';
import { RecordSelectors } from '@app/store/record/record.selectors';
import { Store } from '@ngxs/store';
import { EMPTY, Observable, forkJoin, mergeMap, of, switchMap } from 'rxjs';
import { AuthService } from '@app/services/auth.service';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { WebviewService } from '@app/services/webview.service';
import { OS } from '@app/shared/enum/date';
import { NoteBlobService } from '@app/services/noteblob.service';
@Injectable({
  providedIn: 'root'
})
export class FacesheetEditResolverService implements Resolve<RecordList> {

  constructor(
    private store: Store,
    private apiService: ApiService,
    private router: Router,
    private authService: AuthService,
    private webViewService: WebviewService,
    private noteblobService: NoteBlobService
  ) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<RecordList> {
    // get path no outlet
    let path = state.url.split('(')[0] || '';
    // check comp role
    let flag = this.authService.compRoleCheck(path);
    if (!flag && route.outlet && route.outlet !== '') {
      this.router.navigate([path], { replaceUrl: true });
      return EMPTY;
    }
    //
    const id = route.paramMap.get('noteid');
    const noteid = id === 'null' ? undefined : Number(id);
    const objkbn = route.paramMap.get('objkbn') ?? '';
    const objcd = route.paramMap.get('objcd') ?? '';
    const pageList = this.store.selectSnapshot(RecordSelectors.facesheetList) ?? [];
    const current = pageList.find((item: any) => {
      const { note } = item;
      this.store.dispatch(RemoveInitFacesheetList);
      return (
        note.objkbn === objkbn && note.objcd === objcd
      );
    });

    if (current) {
      this.store.dispatch(new ClearRecordList);
      return of({ ...current, noteid });
    } else if (!current && !noteid) {
      this.router.navigate(['..', { outlets: { edit: null }, relativeTo: route }], { replaceUrl: true });
    }

    return this.apiService.getFaceSheet([{ objkbn, objcd, noteid, IsDecideEndDate: false }]).pipe(
      switchMap((notes) => {
        if (notes.length > 0) {
          const updatedNotes$ = this.noteblobService.fetchAndMapNoteBlobs(notes);
          // Wait for all note updates to complete
          return forkJoin(updatedNotes$);
        }
        return of(notes);
      }),
      mergeMap((list) => {
        if (list && list.length > 0) {
          const note = list[0];
          return of({ note, displayOption: note.displayOption, noteid });
        }
        const previous = this.router
          .getCurrentNavigation()
          ?.previousNavigation?.finalUrl?.toString();
        if (!previous) {
          let isWebView = this.store.selectSnapshot(SettingSelectors.isWebView);
          let isAndroid = this.webViewService.getMobileOS() === OS.ANDROID;
          this.router.navigate(['/404'], { skipLocationChange: !(isWebView && !isAndroid) });
        }
        return EMPTY;
      })
    );
  }
}

